// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/bc43ac88/" + chunkId + "." + __webpack_require__.h() + ".vbc43ac88.js";
};